import api from "./api";

/**
 * Cliente da API de Programa de Fidelidade (`/api/loyalty`).
 *
 * Todas as rotas exigem que o tenant seja do segmento "barbearias" — o backend
 * retorna 403 caso contrário. Por isso o gating de UI (item de menu, rota,
 * mensagem amigável) é responsabilidade exclusiva do frontend e o backend é
 * apenas a segunda linha de defesa.
 *
 * Cada método aceita um `config` opcional do axios — usado por callers que
 * precisam passar `signal` de AbortController para cancelar requests em flight
 * (ex.: lista de cartões recarregada quando o chip de filtro muda).
 */

/**
 * Retorna o programa do tenant autenticado.
 * Backend devolve 404 quando o programa ainda não foi configurado — o caller
 * deve interpretar isso como estado "vazio motivacional", não como erro.
 *
 * @param {import("axios").AxiosRequestConfig} [config]
 * @returns {Promise<import("axios").AxiosResponse>}
 */
export const getProgram = (config = {}) => api.get("/loyalty/program", config);

/**
 * Cria ou atualiza (upsert) o programa do tenant.
 *
 * @param {{ requiredVisits: number, rewardDescription: string, isActive?: boolean }} data
 * @param {import("axios").AxiosRequestConfig} [config]
 * @returns {Promise<import("axios").AxiosResponse>}
 */
export const saveProgram = (data, config = {}) =>
  api.post("/loyalty/program", data, config);

/**
 * Lista cartões de fidelidade paginados.
 *
 * @param {{ page?: number, limit?: number, nearReward?: boolean }} [params]
 * @param {import("axios").AxiosRequestConfig} [config]
 * @returns {Promise<import("axios").AxiosResponse>}
 */
export const getCards = (params = {}, config = {}) =>
  api.get("/loyalty/cards", { ...config, params });

/**
 * Retorna métricas agregadas do programa do tenant.
 * Backend devolve `{ totalCards, totalRewardsGiven, nearRewardCount, programActive }`.
 *
 * @param {import("axios").AxiosRequestConfig} [config]
 * @returns {Promise<import("axios").AxiosResponse>}
 */
export const getMetrics = (config = {}) => api.get("/loyalty/metrics", config);
